module.exports = __webpack_public_path__ + "static/media/Silver-Host-Reseller.6822aef0.png";